import React, { useEffect, useState, useRef } from "react";
import { API } from "../../helper/Api";
import Select from "react-select"; // Import React Select
import { useNavigate, Link } from "react-router-dom";
import { useRole } from "../contextApi/RoleContext";
import Multiselect from "multiselect-react-dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const AddRoles = () => {
  // State to track selected permissions and role/category
    const { setRole, role, setPermission, permission, setUserDetails,userDetails} =
      useRole();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BASE_URL;
  const topRef = useRef(null);
  const [shakeName, setShakeName] = useState(false); // State for username shake
  const [isAddRolePopupOpen, setAddRolePopupOpen] = useState(false);
  const [newRole, setNewRole] = useState("");
  const [err, setErr] = useState("");
  const [role1, setRole1] = useState("");
  const [getrole, setGetRoles] = useState([]);
  const [matchedRole, setMatchedRole] = useState(null);
  const [permissions, setPermissions] = useState({
    view: false,
    edit: false,
    add: false,
  });
  const [isCategoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState(""); // State for message
  const [users, setUsers] = useState([]); // State for selected users
  const [category1, setCategory1] = useState([]); // State for selected users
  const [userOptions, setUserOptions] = useState([]); // Options for the Users dropdown
  const [categoryOptions, setCategoryOptions] = useState([]); // Options for the category dropdown
  // State to track parent checkboxes and expand/collapse
  const [state, setState] = useState([]);
  const [roleState, setRoleState] = useState([]);
  const [getRole, setGetRole] = useState(false);
  const [getPermission, setGetPermission] = useState(false);
  const [storeCode, setStoreCode] = useState([]);
  let track = false;
  const excludeLabels = ["Roles", "Users"];

  // Define fetchData outside useEffect to call it explicitly
  const fetchData = async () => {
    try {
      let setId=role;
      if(userDetails.usertype?.trim() ==="CORP"){
setId=0;
      }
      const res = await API.accessSetting("getrole",setId);
      if (res.success) {
        setGetRoles(res.content);
        console.log("roles are here", res);
        // handle response if needed
      } else {
        console.log("Error in fetching roles");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchRolePermission = async (id) => {
    try {
      const res = await API.accessSetting("getRolePermission", id);
      if (res.success) {
        //  console.log("permission",res);
        setRoleState(res);
        // sendResponse();
        console.log("$", roleState);
      } else {
        console.log("Error in fetching category");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataUsers = async () => {
    try {
      const res = await API.accessSetting("getuser");
      if (res.success) {
        // Assuming API returns a list of users, prepare options for the dropdown
        const userOptions = res.content.map((user) => ({
          value: user.id,
          label: user.username,
        }));
        setUserOptions(userOptions);
        console.log("user are here", res);
        // handle response if needed
      } else {
        console.log("Error in fetching users");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDataCategory = async () => {
    try {
      const res = await API.accessSetting("getcategory");
      if (res.success) {
        // Assuming API returns a list of users, prepare options for the dropdown
        const catOptions = res.content.map((user) => ({
          [`parent${user.id}`]: {
            value: user.id,
            label: user.category_name,
            checked: false,
            expanded: true,
            children: ["View", "List", "Edit", "Add", "Delete"].map(
              (child) => ({
                value: child, // child name (e.g., "View")
                ...(user.category_name.includes("Systems")
                  ? {
                      subChilds: ["Roles", "Users"].map((child, ind) => ({
                        name: child,
                        checked: false, // default checked state
                      })),
                    }
                  : {}),
                checked: false, // default checked state
              })
            ),
          },
        }));

        console.log(catOptions);
        setCategoryOptions(catOptions);
        setState(catOptions);
        // console.log("user are here", res);
        // handle response if needed
      } else {
        console.log("Error in fetching category");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  ///get the store code /////
  // const fetchStoreCode = async () => {
  //   try {
  //     const res = await fetch(`${API_URL}priceLevel.php`);
  //     // Check if the response is successful (status 200)
  //     if (!res.ok) {
  //       throw new Error("Network response was not ok");
  //     }
  //     const result = await res.json();
  //     const extractCode = result.ApiDocument.Response.PriceLevels.map(
  //       (item) => {
  //         return { code: item.Code };
  //       }
  //     ).filter((item) => item.code);
  //     setStoreCode(extractCode);
  //     // console.log("store code", extractCode);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  //////////////////////////////

  const submitSetting = async (data) => {
    try {
      const res = await API.accessSetting("submit", data);
      if (res.success) {
        toast.success("Permission setup successfully!", {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
        // setAlertMessage("Permission setup successfully!");
        // setAlertVisible(true);
        // setTimeout(() => setAlertVisible(false), 3000); // Hide the alert after 3 seconds
        fetchData();
        setNewRole("");
        setRole1("");
        fetchDataCategory();
      } else {
        console.log("Error in form submitting");
        toast.error("Permission setup failed. Please try again", {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
        // setAlertMessage("Permission setup failed. Please try again.");
        // setAlertVisible(true);
        // setTimeout(() => setAlertVisible(false), 3000); // Hide the alert after 3 seconds
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  const handleNewRole = (e) => {
    setGetRole(false);
    setNewRole(e.target.value);
    let getName = e.target.value;
    if (getName.trim()) {
      var filterVal = getrole.filter(
        (item) =>
          item.role_name.trim().toLowerCase() === getName.trim().toLowerCase()
      );
      // Log whether a match was found and its details
      if (filterVal.length > 0) {
        console.log("Matching role found:", filterVal);
        setMatchedRole(`The above role already exist`);
      } else {
        setMatchedRole(null);
      }
    }
  };
  // Call fetchData initially when the component mounts
  useEffect(() => {
    fetchData();
    fetchDataUsers();
    fetchDataCategory();
  //  fetchStoreCode();
  }, []);

  useEffect(() => {
    console.log("role state", roleState);

    const getRolesPerm =
      roleState.content?.find((item) => item.category_id === "8") || {}; // Default to empty object
    const getUsersPerm =
      roleState.content?.find((item) => item.category_id === "9") || {}; // Default to empty object

    const updatedState = state?.map((parentObj) => {
      const [parentKey, parentData] = Object.entries(parentObj)[0];

      const matchingPermission = roleState.content.find(
        (item) => item.category_id === parentData.value
      );

      if (matchingPermission) {
        parentData.children = parentData.children?.map((child) => {
          switch (child.value) {
            case "View":
              return {
                ...child,
                checked: matchingPermission.view_permission === "1",
                subChilds: child.subChilds?.map((subChild) => ({
                  ...subChild,
                  checked:
                    matchingPermission.category_id === "6" &&
                    ((subChild.name === "Roles" &&
                      getRolesPerm.view_permission === "1") ||
                      (subChild.name === "Users" &&
                        getUsersPerm.view_permission === "1")),
                })),
              };
            case "List":
              return {
                ...child,
                checked: matchingPermission.list_permission === "1",
                subChilds: child.subChilds?.map((subChild) => ({
                  ...subChild,
                  checked:
                    matchingPermission.category_id === "6" &&
                    ((subChild.name === "Roles" &&
                      getRolesPerm.list_permission === "1") ||
                      (subChild.name === "Users" &&
                        getUsersPerm.list_permission === "1")),
                })),
              };
            case "Edit":
              return {
                ...child,
                checked: matchingPermission.edit_permission === "1",
                subChilds: child.subChilds?.map((subChild) => ({
                  ...subChild,
                  checked:
                    matchingPermission.category_id === "6" &&
                    ((subChild.name === "Roles" &&
                      getRolesPerm.edit_permission === "1") ||
                      (subChild.name === "Users" &&
                        getUsersPerm.edit_permission === "1")),
                })),
              };
            case "Add":
              return {
                ...child,
                checked: matchingPermission.add_permission === "1",
                subChilds: child.subChilds?.map((subChild) => ({
                  ...subChild,
                  checked:
                    matchingPermission.category_id === "6" &&
                    ((subChild.name === "Roles" &&
                      getRolesPerm.add_permission === "1") ||
                      (subChild.name === "Users" &&
                        getUsersPerm.add_permission === "1")),
                })),
              };
            case "Delete":
              return {
                ...child,
                checked: matchingPermission.delete_permission === "1",
                subChilds: child.subChilds?.map((subChild) => ({
                  ...subChild,
                  checked:
                    matchingPermission.category_id === "6" &&
                    ((subChild.name === "Roles" &&
                      getRolesPerm.delete_permission === "1") ||
                      (subChild.name === "Users" &&
                        getUsersPerm.delete_permission === "1")),
                })),
              };
            default:
              return child;
          }
        });

        // Check if any child is checked
        const anyChildChecked = parentData.children?.some(
          (child) => child.checked
        );

        // Update parent checked and expanded status if any child is checked
        parentData.checked = anyChildChecked;
        parentData.expanded = true;

        return { [parentKey]: parentData };
      }
      return parentObj; // Ensure the original object is returned if no matchingPermission
    });

    console.log("complete_state", updatedState);
    setState(updatedState);
  }, [roleState]);
  // const toggleCategoryDropdown = () => {
  //   setCategoryDropdownOpen(!isCategoryDropdownOpen);
  // };

  // const handleCategoryChange = (event) => {
  //   const { value, checked } = event.target;
  //   if (checked) {
  //     setCategory((prev) => [...prev, value]);
  //   } else {
  //     setCategory((prev) => prev.filter((item) => item !== value));
  //   }
  // };

  // const handleSelectAllChange = (event) => {
  //   if (event.target.checked) {
  //     setCategory(categoryOptions.map((option) => option.value));
  //   } else {
  //     setCategory([]);
  //   }
  // };

  const handlePermissionChange = (event) => {
    const { value, checked } = event.target;
    setPermissions((prev) => ({
      ...prev,
      [value]: checked,
    }));
  };
  const getFilteredData = (data) => {
    return data
      .map((item) => {
        const parentKey = Object.keys(item)[0]; // Extract dynamic parent key
        const parent = item[parentKey];

        // Filter children with checked = true
        const filteredChildren = parent.children.filter(
          (child) => child.checked
        );

        // Include parent if either parent or any of its children are checked
        if (parent.checked || filteredChildren.length > 0) {
          return {
            [parentKey]: {
              ...parent,
              children: filteredChildren, // Include only checked children
            },
          };
        }

        return null; // Exclude parents with no checked property
      })
      .filter(Boolean); // Remove null values
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      track = false;
      const filteredData = getFilteredData(state);
      console.log(filteredData);
      topRef.current.scrollIntoView({ behavior: "smooth" });
      if (newRole === "") {
        setGetRole(true);
        track = true;
      }
      if (matchedRole !== null) {
        track = true;
      }
      if (filteredData == "") {
        //console.log("##");
        setGetPermission(true);
        track = true;
      }
      if (!track) {
        const res = await API.accessSetting("addrole", newRole.trim());
        if (res.success) {
          const payload = prepareDataForAPI(res.inserted_id.toString());
          submitSetting(payload);
        }
        if (topRef.current) {
          topRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error); // Handle errors
    }
  };
  const openAddRolePopup = () => {
    setAddRolePopupOpen(true);
  };

  const closeAddRolePopup = () => {
    setAddRolePopupOpen(false);
    setNewRole("");
    setErr("");
  };

  const addNewRole = async () => {
    if (newRole.trim() === "") {
      setErr("Role is required");
      setShakeName(true); // Trigger the shake effect
      setTimeout(() => setShakeName(false), 1000); // Reset shake effect after 1s
    } else {
      if (newRole.trim()) {
        var filterVal = getrole.filter(
          (item) =>
            item.role_name.trim().toLowerCase() === newRole.trim().toLowerCase()
        );
        // Log whether a match was found and its details
        if (filterVal.length > 0) {
          console.log("Matching role found:", filterVal);
          setMatchedRole(`The given role already exist`);
        } else {
          console.log("Matching role not found:", filterVal);
          setMatchedRole(null);
          closeAddRolePopup();

          const res = await API.accessSetting("addrole", newRole.trim());
          if (res.success) {
            //  setGetRoles(res.content);
            console.log("role added successfully");
            setAlertMessage("The role has been added successfully");
            setAlertVisible(true);
            fetchData();
            setTimeout(() => setAlertVisible(false), 3000); // Hide the alert after 3 seconds
            // handle response if needed
          } else {
            setAlertMessage(
              "There was an error adding the role. Please try again."
            );
            setAlertVisible(true);
            setTimeout(() => setAlertVisible(false), 3000); // Hide the alert after 3 seconds
          }
        }
      }
    }
  };

  const handleParentCheckboxChange = (parentKey) => {
    setGetPermission(false);
    const isChecked = !state.find((item) => item[parentKey])[parentKey].checked;

    setState((prevState) => {
      const newState = [...prevState];
      const parentIndex = prevState.findIndex((item) =>
        item.hasOwnProperty(parentKey)
      );

      if (parentIndex !== -1) {
        // Toggle parent checked state
        newState[parentIndex][parentKey].checked = isChecked;

        // Set all child checkboxes to the same value
        newState[parentIndex][parentKey].children = newState[parentIndex][
          parentKey
        ].children.map((child) => ({
          ...child, // preserve other properties like 'value'
          checked: isChecked, // set checked state for all children
        }));
        //update the subchild value
        newState[parentIndex][parentKey].children = newState[parentIndex][
          parentKey
        ].children.map((child) => ({
          ...child, // preserve other properties
          checked: isChecked,
          subChilds: child.subChilds?.map((sub) => ({
            ...sub,
            checked: isChecked,
          })),
        }));
      }

      return newState;
    });
  };

  const handleSetRole = (e) => {
    setRole1(e.target.value);
    let getRoleIds = e.target.value;
    if (getRoleIds) {
      fetchRolePermission(getRoleIds);
    } else {
      fetchDataCategory();
    }
  };

  const handleChildCheckboxChange = (parentKey, childValue, subChildValue) => {
    console.log("checkbox values->", parentKey, childValue, subChildValue);
    setGetPermission(false);
    if (subChildValue === "Roles" || subChildValue === "Users") {
      console.log("1");
      setState((prevState) => {
        const newState = [...prevState];
        const parentIndex = prevState.findIndex((item) =>
          item.hasOwnProperty(parentKey)
        );

        if (parentIndex !== -1) {
          // Find the specific child
          const childIndex = newState[parentIndex][
            parentKey
          ].children.findIndex((child) => child.value === childValue);

          const subChildIndex = newState[parentIndex][parentKey].children[
            childIndex
          ].subChilds.findIndex((child) => child.name === subChildValue);

          if (childIndex !== -1) {
            // Toggle the checked state of the child
            newState[parentIndex][parentKey].children[childIndex].checked =
              !newState[parentIndex][parentKey].children[childIndex].checked;

            newState[parentIndex][parentKey].children[childIndex].subChilds[
              subChildIndex
            ].checked =
              !newState[parentIndex][parentKey].children[childIndex].subChilds[
                subChildIndex
              ].checked;

            const subChildChecked = newState[parentIndex][parentKey].children[
              childIndex
            ].subChilds.some((child) => child.checked);
            // Update the parent checked state
            newState[parentIndex][parentKey].children[childIndex].checked =
              subChildChecked;
            // Check if any child is checked to update the parent state
            const anyChecked = newState[parentIndex][parentKey].children.some(
              (child) => child.checked
            );
            newState[parentIndex][parentKey].checked = anyChecked;

            // newState[parentIndex][parentKey].checked = subAnyChecked;
          }
        }

        return newState;
      });
    } else {
      console.log("2");
      setState((prevState) => {
        const newState = [...prevState];
        const parentIndex = prevState.findIndex((item) =>
          item.hasOwnProperty(parentKey)
        );

        if (parentIndex !== -1) {
          // Find the specific child
          const childIndex = newState[parentIndex][
            parentKey
          ].children.findIndex((child) => child.value === childValue);

          if (childIndex !== -1) {
            // Toggle the checked state of the child
            newState[parentIndex][parentKey].children[childIndex].checked =
              !newState[parentIndex][parentKey].children[childIndex].checked;

            // Check if any child is checked to update the parent state
            const anyChecked =
              newState[parentIndex][parentKey].children[childIndex].checked;
            // .some(
            //   (child) => child.checked
            // );
            //check the view,edit,etc checkbox is checked?
            const updateParentChecked = newState[parentIndex][
              parentKey
            ].children.some((child) => child.checked);
            //update the subchild here
            newState[parentIndex][parentKey].children[childIndex].subChilds =
              newState[parentIndex][parentKey].children[
                childIndex
              ].subChilds?.map((child) => ({
                ...child,
                checked: anyChecked,
              }));

            // Update the parent checked state
            newState[parentIndex][parentKey].checked = updateParentChecked;
          }
        }
        return newState;
      });
    }
  };

  const toggleExpand = (parentKey) => {
    setState((prevState) => {
      const newState = [...prevState];
      const parentIndex = prevState.findIndex((item) =>
        item.hasOwnProperty(parentKey)
      );

      if (parentIndex !== -1) {
        // Toggle expanded state
        newState[parentIndex][parentKey].expanded =
          !newState[parentIndex][parentKey].expanded;
      }

      return newState;
    });
  };

  const updateParentLabels = (data) => {
    const updatedData = data.map((item) => ({ ...item })); // Shallow copy of the data

    // Find the "Systems" parent object dynamically
    const systems = updatedData.find((parentObj) => {
      const parentKey = Object.keys(parentObj)[0];
      return parentObj[parentKey]?.label === "Systems";
    });

    if (systems) {
      const parentKey = Object.keys(systems)[0];
      const { children } = systems[parentKey];

      // Check and update "Roles" and "Users" based on subChilds' checked status
      children.forEach((child) => {
        if (["View", "List", "Edit", "Add", "Delete"].includes(child.value)) {
          child.subChilds?.forEach((subChild) => {
            const targetParent = updatedData.find((parentObj) => {
              const key = Object.keys(parentObj)[0];
              return parentObj[key]?.label === subChild.name;
            });

            if (targetParent) {
              const targetKey = Object.keys(targetParent)[0];
              const targetParentData = targetParent[targetKey];

              // Update the matching child
              const targetChild = targetParentData?.children?.find(
                (tc) => tc.value === child.value
              );
              if (targetChild) {
                targetChild.checked = subChild.checked;
              }

              // Update parent checked status
              targetParentData.checked = targetParentData.children?.some(
                (tc) => tc.checked
              );
            }
          });
        }
      });
    }

    return updatedData;
  };

  ////////end//////////////////////////////
  const getSelectedValues = () => {
    // Map through state to find all selected parent and child values
    const updatedState = updateParentLabels(state);
    //console.log("final", updatedState);

    const selectedValues = state
      .map((parentObj) => {
        const parentKey = Object.keys(parentObj)[0];
        const { checked, children } = parentObj[parentKey];
        // If the parent is checked, get the child values as well
        if (checked) {
          const selectedChildren = children
            .filter((child) => child.checked) // Filter only checked children
            .map((child) => child.value); // Map to get the value of checked children

          return {
            parent: parentObj[parentKey].label,
            value: parentObj[parentKey].value,
            children: selectedChildren,
          };
        }
        return null;
      })
      .filter((item) => item !== null); // Filter out null values (unselected parents)

    console.log(selectedValues); // For debugging purposes
    return selectedValues;
  };
  const prepareDataForAPI = (id) => {
    const selectedValues = getSelectedValues();

    const apiPayload = {
      selectedPermissions: selectedValues.map((item) => ({
        parent: item.parent,
        children: item.children,
        value: item.value,
      })),
      role: id,
      newrole: newRole,
    };

    console.log("API Payload:", apiPayload); // For debugging purposes
    return apiPayload;
  };

  ///get the selected store code//
  const handleStoreCode = (selectedValues) => {
    console.log("selectedVal", selectedValues);
  };
  ///end////

  // const containerStyles = {
  //   padding: "30px",
  //   width: "60%",
  //   borderRadius: "8px",
  //   // backgroundColor: '#f8f9fa',
  //   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  // };

  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };

  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    // marginBottom: '15px',
    outline: "none",
    cursor: "pointer",
    height: "40px",
    color: "black",
  };

  const dropdownStyles = {
    position: "absolute",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    width: "90%",
    zIndex: "1000",
    maxHeight: "200px",
    overflowY: "auto",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    padding: "10px",
  };

  const checkboxStyles = {
    margin: "5px 0",
  };

  const permissionLabelStyles = {
    marginLeft: "5px",
  };
  const invalidFeedbackStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "-10px",
  };

  return (
    <div className="container-fluid page-body-wrapper" ref={topRef}>
      {/* Add the Shake Keyframe Animation */}
      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0); }
          }

          .shake {
            animation: shake 0.5s ease-in-out;
          }
        `}
      </style>
      <div className="main-panel">
        <div className="content-wrapper">
          <ToastContainer
            position="top-center"
            autoClose={500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="container mainbody">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 className="form-header">Role Permissions Setup</h2>
              <Link to="/roles" className="backButton">
                <i class="mdi mdi-arrow-left"></i>Back
              </Link>
            </div>
            {alertVisible && (
              <div
                style={{
                  marginBottom: "1rem",
                  padding: "1rem",
                  backgroundColor: alertMessage.includes("error")
                    ? "#dc3545"
                    : "#28a745",
                  color: "white",
                  borderRadius: "5px",
                  textAlign: "center",
                }}
              >
                {alertMessage}
              </div>
            )}
            <form onSubmit={handleFormSubmit} style={{ marginTop: "15px" }}>
              {/* Role label in a separate row */}
              <div className="form-group">
                <label htmlFor="newrole" style={labelStyles}>
                  Role Name:<span className="requireds">*</span>
                  {getRole && (
                    <span className="fieldValidation">(Role is required)</span>
                  )}{" "}
                </label>
                <input
                  id="newrole"
                  type="text"
                  placeholder="Enter role name"
                  value={newRole}
                  onChange={handleNewRole}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                  }}
                />
                {matchedRole !== null ? (
                  <p style={invalidFeedbackStyle}>{matchedRole}</p>
                ) : (
                  ""
                )}
                {/* <label htmlFor="storecode">Store Code:</label>
                <Multiselect
                  id="storecode"
                  displayValue="code"
                  onKeyPressFn={function noRefCheck() {}}
                  onRemove={function noRefCheck() {}}
                  onSearch={function noRefCheck() {}}
                  onSelect={handleStoreCode}
                  options={storeCode}
                  placeholder="Select Store Code"
                /> */}
                <label htmlFor="role" style={labelStyles}>
                  Copy Role Permission From:
                </label>
                <select
                  id="role"
                  className="form-control"
                  value={role1}
                  onChange={handleSetRole}
                  style={{ ...selectStyles, marginRight: "10px" }}
                >
                  <option value="">Select</option>
                  {getrole
                    ? getrole.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.role_name}
                        </option>
                      ))
                    : ""}
                </select>
              </div>

              {/* Role select and plus icon in the same row */}
              {/* <div
                className="form-group"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "-20px",
                }}
              >
                
                <button
                  type="button"
                  onClick={openAddRolePopup}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <i
                    className="mdi mdi-plus-circle"
                    style={{ fontSize: "24px", color: "#007bff" }}
                  ></i>
                </button>
              </div> */}
              {/* Add Role Popup */}
              {/* {isAddRolePopupOpen && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                  }}
                >
                  <div
                    className={`${shakeName ? "shake" : ""}`}
                    style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "8px",
                      width: "300px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                    }}
                  >
                    <label style={{ marginBottom: "15px", fontWeight: "600" }}>
                      Add New Role
                    </label>
                    {err && <div style={invalidFeedbackStyle}>{err}</div>}
                    <input
                      id="newrole"
                      type="text"
                      placeholder="Enter role name"
                      value={newRole}
                      onChange={(e) => setNewRole(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        marginBottom: "15px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                        fontSize: "14px",
                      }}
                    />
                    {matchedRole !== null ? (
                      <p style={invalidFeedbackStyle}>{matchedRole}</p>
                    ) : (
                      ""
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    >
                      <button
                        type="button"
                        onClick={closeAddRolePopup}
                        style={{
                          padding: "8px 12px",
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={addNewRole}
                        style={{
                          padding: "8px 12px",
                          backgroundColor: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              )} */}

              {/* <div className="container mt-5"> */}
              <label style={labelStyles}>
                Permissions:<span className="requireds">*</span>
                {getPermission && (
                  <span className="fieldValidation">
                    (Permission is required)
                  </span>
                )}{" "}
              </label>
              <ul className="list-unstyled">
                {state
                  .filter((parentObj) => {
                    const parentKey = Object.keys(parentObj)[0]; // Get the dynamic key
                    const label = parentObj[parentKey]?.label; // Access label dynamically
                    return !excludeLabels.includes(label); // Exclude Roles and Users
                  })
                  .map((parentObj, index) => {
                    const parentKey = Object.keys(parentObj)[0];
                    const {
                      checked,
                      expanded,
                      children,
                      subcategory = null,
                    } = parentObj[parentKey];

                    return (
                      <li key={parentKey}>
                        <div className="d-flex align-items-center">
                          {/* Toggle Arrow */}
                          <button
                            type="button"
                            className="btn btn-link p-0 me-2"
                            onClick={() => toggleExpand(parentKey)}
                            style={{
                              fontSize: "13px",
                              textDecoration: "none",
                              color: "gray",
                            }}
                          >
                            {expanded ? "▼" : "►"}
                          </button>
                          <div
                            className="form-check"
                            style={{ marginTop: "7px", paddingLeft: "5px" }}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              style={{ marginLeft: "-2%", width: "20px" }}
                              id={parentKey}
                              checked={checked}
                              onChange={() =>
                                handleParentCheckboxChange(parentKey)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={parentKey}
                            >
                              {parentObj[parentKey].label}
                            </label>
                          </div>
                        </div>

                        {expanded && (
                          <ul
                            className="child-list ms-4"
                            style={{ paddingLeft: "3.3rem" }}
                          >
                            {children.map((child, indexes) => (
                              <li
                                key={child.value}
                                style={{ listStyle: "none", width: "0%" }}
                              >
                                <div
                                  className="form-check"
                                  style={{
                                    marginTop: "7px",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{ marginLeft: "0px", width: "20px" }}
                                    id={child.value}
                                    checked={child.checked}
                                    onChange={() =>
                                      handleChildCheckboxChange(
                                        parentKey,
                                        child.value
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={child.value}
                                  >
                                    {child.value.replace("-", " ")}
                                  </label>
                                </div>
                                {child.subChilds
                                  ? child.subChilds.map((items, index) => {
                                      //  console.log("ite", items);
                                      return (
                                        <div
                                          key={items.name}
                                          className="form-check"
                                          style={{
                                            marginTop: "7px",
                                            marginLeft: "7px",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            style={{
                                              marginLeft: "20px",
                                              width: "20px",
                                            }}
                                            id={items.name}
                                            checked={items.checked}
                                            onChange={() =>
                                              handleChildCheckboxChange(
                                                parentKey,
                                                child.value,
                                                items.name
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            style={{ marginLeft: "40px" }}
                                            htmlFor={items.name}
                                          >
                                            {items.name}
                                          </label>
                                        </div>
                                      );
                                    })
                                  : null}
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
              </ul>
              {/* </div> */}

              {/* Submit button */}
              <div style={{ display: "flex", gap: "5px" }}>
                <button
                  type="submit"
                  className="submit-btn"
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    backgroundColor: "rgb(108,117,125)",
                    color: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  onClick={() => navigate("/roles")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                >
                  Save Permissions
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRoles;
